<template>
    <checkbox
    class="mt-4"
    @change="v => $emit('input', v)"
    :small="true"
    :checked="value == true"
    :label="row.display_content"
    v-bind="$attrs" />
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            },
            value: {
                type: Boolean,
                default: false
            }
        }

    }
</script>